import type { RouterProviderProps } from 'react-router-dom'
import { RouterProvider } from 'react-router-dom'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { Providers } from './providers'

type AppProps = {
  router: RouterProviderProps['router']
}

export function App({ router }: AppProps) {
  return (
    <ErrorBoundary>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  )
}
